<template>
  <v-container id="HomePage" fluid tag="section">
    <v-app-bar color="#b88611" dense dark>
      <v-toolbar-title>What the order had</v-toolbar-title>

      <v-spacer />
    </v-app-bar>
    <div>
      <v-row>
        <v-col cols="12" md="12">
          <base-material-card color="#455A64" class="px-5 py-3" title="Here they are !!">
            <v-card-text class="px-0 pb-0">
              <v-sheet />

              <v-row>
                <v-col lg="12" sm="12" cols="12">
                  <v-card-title>
                    <v-spacer />
                    <v-text-field v-model="searchO" append-icon="mdi-magnify" label="Search" single-line hide-details
                      clearable dense outlined />
                  </v-card-title>
                  <v-data-table :headers="headers" :items="items" :search="searchO">
                  </v-data-table>
                  <v-col lg="8" sm="8" cols="8">
                    <!-- <v-btn
                      block
                      color="green"
                      @click="generatePDF"
                    >
                      Print Details
                    </v-btn> -->
                  </v-col>
                </v-col>
              </v-row>
              <!-- -----------------------Loader---------------------- -->
              <v-row>
                <v-dialog v-model="loader" persistent width="200">
                  <v-card>
                    <v-card-text>
                      <v-container>
                        <v-row class="justify-center">
                          Please Wait...
                        </v-row>
                        <v-row class="mt-2 justify-center">
                          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import db from './api/firebaseInit';
// import firebase from 'firebase'
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueSimpleAlert from 'vue-simple-alert';

Vue.use(VueSimpleAlert, VueCookies);

export default {
  data: function () {
    return {
      dataReady: false,
      loader: true,
      items: [],
      searchO: '',
      headers: [
        { text: 'Barcode', value: 'barcode' },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Qty', value: 'quantity' },
      ],
      thisId: '',
    };
  },
  mounted() {
    if (!VueCookies.get('maman')) {
      this.$router.push('/');
    }
    this.thisId = VueCookies.get('seeMoreBackup');
    // VueCookies.remove('seeMore')
    this.mountRun();
  },

  methods: {
    mountRun: function () {
      this.toUpdate = null;
      this.toUpdateID = '';
      this.toUpdateInStock = '';
      this.toUpdateQuantity = '';
      this.items = [];
      db.collection('ordersBackup')
        .where('orderId', '==', this.thisId)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // console.log(doc.data())
            var tempObj = {
              barcode: doc.data().barcode,
              name: doc.data().name,
              description: doc.data().description,
              quantity: doc.data().quantity,
              itemId: doc.data().itemId,
              id: doc.id,
            };
            this.items.push(tempObj);
          });
          this.loader = false;
        })
        .catch((err) => {
          const error = err;
          // console.log('Error getting documents', error)
        });
    },
    generatePDF: function (e) { },
  },
};
</script>
